import { theme } from './theme';

/** Visually hidden, available to screen readers and keyboard focus. */
export const srOnly = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  borderWidth: 0
} as const;

/** Keyboard-only focus ring — use with `&:focus-visible`, not `&:focus`. */
export const focusOutline = {
  outline: `3px ${theme.palette.common.buttonPrimaryDefault} solid`,
  outlineOffset: '5px'
};
